<template>
  <div class="pneu-desenho ml-4 mr-4">
    <b-form>
      <b-row>
        <!-- -->

        <b-col cols="1">
          <br />
          <b-button
            variant="warning"
            class="ml-5 mt-2"
            v-b-modal.modal-multi-desenho
            @click="reset()"
            >Novo</b-button
          >
        </b-col>
      </b-row>
    </b-form>

    <div class="d-flex justify-content-center mb-3"></div>
    <!--tbl de dados -->
    <b-table
      id="desenho"
      small
      hover
      striped
      sticky-header="818px"
      :items="desenhos"
      :fields="fields"
    >
      <template slot="cell(actions)" slot-scope="data">
        <b-button
          @click="editdesenho(data.item)"
          title="Editar desenho"
          size="sm"
          variant="primary"
          class="mr-2 mt-2"
          v-b-modal.modal-multi-desenho
        >
          <i class="fa fa-exclamation-circle"></i>
        </b-button>
      </template>
    </b-table>

    <!--  MODAL GRAVAÇÃO RELACAO DA desenho pneu -->
    <!--  MODAL GRAVAÇÃO RELACAO DA desenho pneu -->
    <div>
      <b-modal
        id="modal-multi-desenho"
        hide-footer
        size="lg"
        title="Cadastro de desenhos"
      >
        <!-- -->
        <div>
          <b-row>
            <b-col cols="6">
              <label for="input-filial">Empresa</label>
              <div>
                <b-form-select
                  id="fun-empresa"
                  v-model="des.empresa_id"
                  required
                  :options="empresas"
                  class="mb-3"
                  text-field="empresa"
                >
                </b-form-select>
              </div>
            </b-col>

            <b-col cols="6">
              <label for="input-live">desenho</label>
              <b-form-input
                v-model="des.desenho"
                placeholder="Digite a descrição do desenho"
              ></b-form-input>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="4" class="mb-3">
              <label for="input-live">Sulco ideal</label>
              <b-form-input
                v-model="des.sulco_ideal"
                required="required"
                placeholder="Nro carro"
              ></b-form-input>
            </b-col>

            <b-col cols="4" class="mb-3">
              <label for="input-live">Sulco alerta</label>
              <b-form-input
                v-model="des.sulco_alerta"
                required="required"
                placeholder="Nro carro"
              ></b-form-input>
            </b-col>

            <b-col cols="4" class="mb-3">
              <label for="input-live">Sulcdeso crítico</label>
              <b-form-input
                v-model="des.sulco_critico"
                required="required"
                placeholder="Nro carro"
              ></b-form-input>
            </b-col>
          </b-row>
          <input id="id-desenho" type="hidden" v-model="des.id" />

          <b-button
            class="mt-3"
            variant="success"
            block
            @click="postdesenho(), reset()"
            >Gravar</b-button
          >
        </div>
      </b-modal>
    </div>
    <!--  MODAL GRAVAÇÃO RELACAO DA FROTA INDISPONIVEL -->
  </div>
</template>


<script>
import { baseApiUrl, showError } from "@/global";
import axios from "axios";
import moment from "moment";
import { mapState } from "vuex";

export default {
  computed: { ...mapState(["user"]) },
  name: "Manutencaodesenho",

  data: function () {
    return {
      carregando: false,
      empresas: [],
      des: {},
      desenhos: [],

      //  barra_inicial: 0,
      //  barra_limite: 300000,

      fields: [
        { key: "empresa_id", label: "Empresa", sortable: true },
        { key: "id", label: "Id", sortable: true },
        { key: "desenho", label: "desenho", sortable: true },
        { key: "sulco_ideal", label: "Sulco ideal", sortable: true },
        { key: "sulco_alerta", label: "Sulco alerta", sortable: true },
        { key: "sulco_critico", label: "Sulco crítico", sortable: true },
        {
          key: "dt_cadastro",
          label: "Data Cadastro",
          sortable: true,
          formatter: (value, key, desenhos) => {
            return moment(desenhos.dt_cadastro)
              .format("DD/MM/YYYY - HH:mm")
              .replace("Data inválida", "-");
          },
        },
        {
          key: "dt_alteracao",
          label: "Data Alteracao",
          sortable: true,
          formatter: (value, key, desenhos) => {
            return moment(desenhos.dt_alteracao)
              .format("DD/MM/YYYY - HH:mm")
              .replace("Data inválida", "-");
          },
        },
        { key: "actions", label: "Ações" },
      ],
    };
  },

  components: {},
  methods: {
    loadEmpresa() {
      let params = {
        psg: this.user.psg,
        id_grupo_empresa: `${this.user.id_grupo_empresa}`,
      };

      const url = `${baseApiUrl}/ctr/empresa`;
      axios
        .get(url, { params })
        .then((res) => {
          this.empresas = res.data.map((emp) => {
            return {
              ...emp,
              value: emp.id_empresa,
              empresa: emp.nomeempresarial,
              id_filial_erp: emp.id_filial_erp,
            };
          });
        })
        .catch(showError);
    },

    loaddesenho() {
      let params = {
        psg: this.user.psg,
        empresa_id: `${this.user.id_empresa}`,
      };
      const url = `${baseApiUrl}/pneu/desenho`;
      axios.get(url, { params }).then((res) => {
        this.carregando = false;
        this.desenhos = res.data.map((de) => {
          return { ...de };
        });
      });
    },

    editdesenho(des) {
      this.des = { ...des };
      this.loadEmpresa();
    },

    postdesenho() {
      let corpo = {
        psg: this.user.psg,
        empresa_id: `${this.des.empresa_id}`,
        id_funcionario: `${this.user.id_funcionario}`,
        id: `${this.des.id}`,
        desenho: `${this.des.desenho}`,
        sulco_ideal: `${this.des.sulco_ideal}`,
        sulco_alerta: `${this.des.sulco_alerta}`,
        sulco_critico: `${this.des.sulco_critico}`,
      };

      const url = `${baseApiUrl}/pneu/desenho`;

      axios
        .post(url, corpo)
        .then(() => {
          this.$toasted.global.defaultSuccess();
          this.reset(); //limpar os objetos valores
        })
        .catch(showError);
    },

    reset() {
      this.des = {};
      this.desenho = [];
      this.loaddesenho();
    },
  },

  mounted() {
    this.loadEmpresa();
    this.loaddesenho(); //    se habilitado carrega o grid
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
#selecaostatusx {
  font-size: 0.7em;
}

#desenhos {
  font-size: 0.9em;
  text-align: center;
}
</style>